import { Form, Switch } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { IconText } from '~/features/shared/icons'
import { StepProps } from '../types'

type Props = StepProps

export const StepPlatforms: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          What social media should I focus on?
        </TitlePrimary>

        <CommonClient.Form.InputWrapper
          label={
            <>
              <IconText name="linkedin" /> Linkedin
            </>
          }
          description="Generate posts for LinkedIn"
        >
          <Form.Item name={['platform', 'linkedin']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>

        <CommonClient.Form.InputWrapper
          label={
            <>
              <IconText name="facebook" /> Facebook
            </>
          }
          description="Generate posts for Facebook"
        >
          <Form.Item name={['platform', 'facebook']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>

        <CommonClient.Form.InputWrapper
          label={
            <>
              <IconText name="instagram" /> Instagram
            </>
          }
          description="Generate posts for Instagram"
        >
          <Form.Item name={['platform', 'instagram']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>

        <CommonClient.Form.InputWrapper
          label={
            <>
              <IconText name="x-square" /> Twitter
            </>
          }
          description="Generate posts for Twitter"
        >
          <Form.Item name={['platform', 'twitter']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>

        <CommonClient.Form.InputWrapper
          label={
            <>
              <IconText name="google" /> Google Business Profile
            </>
          }
          description="Generate posts for Google Business Profile"
        >
          <Form.Item name={['platform', 'gmb']}>
            <Switch size="small" />
          </Form.Item>
        </CommonClient.Form.InputWrapper>
      </CommonClient.Onboarding.Step>
    </>
  )
}
